import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { IoFunnel } from "react-icons/io5";
import { Row, Col } from "react-bootstrap";
import moment from "moment";
import isEmpty from "lodash/isEmpty";
import CallService from "../../services/callService";

import * as projectActions from "../../actions/projectActions";
import * as codeActions from "../../actions/codeActions";
import * as userActions from "../../actions/userActions";
import * as serviceActions from "../../actions/serviceActions";
import * as callActions from "../../actions/callActions";
import * as customerActions from "../../actions/customerActions";
import * as modalActions from "../../actions/modalActions";

import HeaderWrapper from "../common/HeaderWrapper";
import CallList from "../call/CallList";
import CallForm from "../call/CallForm";
import FiltersComponent from "../common/FiltersComponent";
import Modal from "../common/Modal";
import ConfirmModal from "../common/ConfirmModal";

import ProjectCallBreakdown from "./ProjectCallBreakdown";

class ProjectCallsPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      call: {},
      filters: {},
      adding: false,
      deleteRecurring: false,
      projectBreakdown: []
    };
  }

  componentDidMount = async () => {
    const { users, services, actions } = this.props;
    await actions.getProject(this.props.match.params.id);

    await this.getProjectBreakdownCalls();

    if (isEmpty(services)) actions.loadServices();
    if (isEmpty(users)) actions.loadUsers();
  };

  onClickDelete = (callId, isRecurring = false) => {
    this.props.actions.requestCallId(callId, false);
    this.setState({ deleteRecurring: isRecurring });
  };

  onClickAdd = () => {
    this.setState({ call: {}, adding: true });
    this.props.actions.showModalSuccess("callDetailsModal");
  };

  onClickView = (callId) => {
    const call = this.state.calls.find((c) => c._id === callId);
    this.setState({ call, adding: false });
    this.props.actions.getCall(callId, true);
  };

  fetchCalls = async (state) => {
    state.filtered = {
      ...state.filtered,
      project: [{ value: this.props.match.params.id }]
    };

    const { calls, pages } = await CallService.loadCalls(state);
    this.setState({ calls, pages });
  };

  handleAdd = async (call) => {
    await this.props.actions.createCall(call);
    await this.props.actions.hideModal();
    await this.reload();
  };

  handleSave = async (call) => {
    await this.props.actions.updateCall(call);
    await this.props.actions.hideModal();
    await this.reload();
  };

  handleDelete = async () => {
    const { callToDelete } = this.props;
    await this.props.actions.deleteCall(callToDelete);
    await this.reload();
  };

  confirmDelSingle = async () => {
    await this.props.actions.deleteCall(this.props.callToDelete);
    await this.props.actions.hideModal();
    await this.reload();
  };

  confirmDelSeries = async () => {
    const callToDelete = this.state.allCalls.find(
      (x) => x._id === this.props.callToDelete
    );
    await this.props.actions.deleteRecurringCalls(callToDelete.recurring_id);
    await this.props.actions.hideModal();
    await this.reload();
    await this.setState({ deleteRecurring: false });
  };

  getProjectBreakdownCalls = async () => {
    const projectBreakdown = await CallService.loadProjectBreakdownCalls({
      ...this.state.filters,
      project: this.props.match.params.id
    });
    this.setState({ projectBreakdown });
  };

  handleChangeFilters = (field, input) => {
    this.setState(
      { filters: { ...this.state.filters, [field]: input } },
      this.getProjectBreakdownCalls
    );
  };

  handleChangeDate = (startDate, endDate) => {
    if (startDate) {
      this.setState(
        {
          filters: {
            ...this.state.filters,
            arrival_date: moment(startDate).startOf("day")
          }
        },
        this.getProjectBreakdownCalls
      );
    }
    if (endDate) {
      this.setState(
        {
          filters: {
            ...this.state.filters,
            completed_date: moment(endDate).endOf("day")
          }
        },
        this.getProjectBreakdownCalls
      );
    }
  };

  resetFilters = () => {
    this.setState(
      {
        filters: {
          assigned_to: [],
          stage: [],
          arrival_date: null,
          completed_date: null
        }
      },
      this.getProjectBreakdownCalls
    );
  };

  render() {
    const { project, contracts, users, auth, services, codes, call, isMobile } =
      this.props;
    const { calls, pages, adding, deleteRecurring } = this.state;
    const actions = (
      <span>
        <button
          className="btn btn-success"
          type="button"
          onClick={this.confirmDelSingle}
        >
          Delete Single
        </button>
        <button
          className="btn btn-success"
          type="button"
          onClick={this.confirmDelSeries}
        >
          Delete Series
        </button>
      </span>
    );
    const callForm = (
      <CallForm
        call={adding ? {} : call}
        contracts={contracts}
        users={users}
        auth={auth}
        customer={project.customer}
        customers={[project.customer]}
        projects={[project]}
        project={project}
        services={services}
        codes={codes}
        onToggle={this.handleToggle}
        onAdd={this.handleAdd}
        onSave={this.handleSave}
        onSaveWithRecurring={this.handleSaveWithRecurring}
        onCancel={this.props.actions.hideModal}
        saving={this.props.savingCall}
        editing
        adding={adding}
        readOnly={!adding}
        recurring={this.state.recurring}
      />
    );
    return (
      <React.Fragment>
        <HeaderWrapper
          breadcrumbs={[
            {
              label: `${project?.name || ""} - ${project?.customer?.name || ""}`
            },
            { label: "Calls" }
          ]}
          isMobile={isMobile}
          onClickAdd={
            project.project_status &&
            project.project_status.label === "In Process" &&
            this.onClickAdd
          }
          onClickAction={[
            {
              action: () => this.setState({ open: !this.state.open }),
              icon: <IoFunnel />
            }
          ]}
        />
        <Row>
          <Col md={12}>
            <FiltersComponent
              open={this.state.open}
              filters={this.state.filters}
              focusedInput={this.state.focusedInput}
              onChangeFilters={this.handleChangeFilters}
              onChangeDate={this.handleChangeDate}
              onFocusChange={(focusedInput) => this.setState({ focusedInput })}
              onReset={this.resetFilters}
              fields={["Status", "Date", "Assigned To"]}
            />
          </Col>
        </Row>
        <div className="content-wrapper sm" style={{ paddingBottom: 15 }}>
          <ProjectCallBreakdown
            auth={auth}
            project={project}
            calls={this.state.projectBreakdown}
            filters={this.state.filters}
          />
        </div>
        <div className="content-wrapper">
          <CallList
            ticketRedirect
            serverSide
            data={calls}
            users={users}
            projects={[project]}
            pages={pages}
            fetchData={this.fetchCalls}
            reloadData={(r) => (this.reload = r)}
            isMobile={isMobile}
            filtered={this.state.filters}
            onClickView={this.onClickView}
            onClickDelete={this.onClickDelete}
            fromProjectPage
          />
          <Modal
            id="callDetailsModal"
            title={adding ? "Create Call" : "Edit Call"}
            body={callForm}
            close={this.props.actions.hideModal}
          />
          <ConfirmModal
            id="callConfirmModal"
            title={
              deleteRecurring
                ? `This call is part of a recurring series`
                : `Delete Call`
            }
            body={
              deleteRecurring
                ? `Do you want to delete this series or this single call?`
                : `Are you sure you want to delete this call?`
            }
            actions={deleteRecurring ? actions : ""}
            close={this.props.actions.hideModal}
            confirm={this.handleDelete}
          />
        </div>
      </React.Fragment>
    );
  }
}

ProjectCallsPage.propTypes = {
  actions: PropTypes.object.isRequired,
  project: PropTypes.object,
  match: PropTypes.object,
  contracts: PropTypes.array,
  users: PropTypes.array,
  auth: PropTypes.object,
  codes: PropTypes.array,
  services: PropTypes.array,
  call: PropTypes.object,
  isMobile: PropTypes.bool,
  savingCall: PropTypes.func,
  callToDelete: PropTypes.object
};

function mapStatesToProps(state) {
  return {
    state: state.reducers,
    project: state.reducers.project,
    call: state.reducers.call,
    codes: state.reducers.codes,
    users: state.reducers.users,
    services: state.reducers.services,
    customers: state.reducers.customers,
    saving: state.reducers.savingProject,
    loading: state.reducers.loading,
    callToDelete: state.reducers.callToDelete
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...customerActions,
        ...projectActions,
        ...callActions,
        ...codeActions,
        ...serviceActions,
        ...userActions,
        ...modalActions
      },
      dispatch
    )
  };
}

export default connect(mapStatesToProps, mapDispatchToProps)(ProjectCallsPage);
